<script>
import Swal from 'sweetalert2';
import i18n from '../i18n';
import { AbilityBuilder, Ability } from '@casl/ability';
import { ABILITY_TOKEN } from '@casl/vue';
import { fetchOUAccess } from '@/helpers/abilities.js';
import { fetchMenus } from '@/helpers/menuApi.js';
import { getEcho } from '@/plugins/echo';
import Notifications from '@/layouts/partials/notifications.vue';

import ApplicationLogo from '@/components/application-logo.vue';
import axios from 'axios';

/**
 * Nav-bar Component
 */
export default {
  inject: {
    $ability: { from: ABILITY_TOKEN },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      suggested_menu: [],
      otherDocuments: [],
      searchUsers: [],
      searchCustomers: [],
      searchBookings: [],
      searchCsr: [],
      searchLoading: false,
      searchQuery: '',
      searchDropdownOpen: false,
      activeIndex: -1,
      searchLimit: 5,
      searchTimer: null,
      taskCount: 0,
      tasks: [],
      taskLoading: false,
      currentTime: Date.now(),
      taskClockTimer: null,
      alertedTaskIds: new Set(),
      // Task alert bell: enabled flag (persisted) and the shared Web Audio
      // context used to synthesize the ring.
      alertSoundEnabled: (() => {
        try {
          return localStorage.getItem('taskAlertSound') !== '0';
        } catch (e) {
          return true;
        }
      })(),
      audioCtx: null,
    };
  },
  components: {
    ApplicationLogo,
    Notifications,
  },


  methods: {
    handleOUselect(event) {
      Swal.fire({
        title: 'Do you want to proceed?',
        text: 'You will be redirected to home page. Any unsaved changes that you made will be discarded.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes!',
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          //if confirmed to delete, then delete all selected rows
          const selectedOu = event.target.value;
          this.$store.commit('setActiveOU', selectedOu);
          
          try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const access = JSON.parse(localStorage.getItem('ouAccess') || '[]');
            const companyMatch = access.find(o => o.ou_code === selectedOu);
            if (companyMatch && companyMatch.company_id && user.id) {
              user.default_company_id = companyMatch.company_id;
              localStorage.setItem('user', JSON.stringify(user));
              
              axios.post(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/set_default_company`, {
                id: user.id,
                default_company_id: companyMatch.company_id,
              }).catch((err) => {
                console.error('Error saving default company to server:', err);
              });
            }
          } catch (e) {
            console.error('Error updating default company locally:', e);
          }

          this.updateAbility();
          this.getOUDetails();
          fetchMenus();
          this.$router.push({ name: 'default' });
        }
        this.loadOU();
      });
    },
    async updateAbility() {
      const { can, rules } = new AbilityBuilder(Ability);
      const roles = localStorage.getItem('userRoles')
        ? JSON.parse(localStorage.getItem('userRoles')).map(
          (item) => item.role_id
        )
        : [];
      // const ou = localStorage.getItem("activeOU");roles.includes(1)
      if (roles.includes(1)) {
        can('manage', 'all');
      } else {
        const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/me/user-permissions`;
        let permissions = [];
        await axios
          .post(url, { roles: roles, ou_code: this.ouCode })
          .then((result) => {
            if (result.data.data) {
              permissions = result.data.data;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            if (permissions.length > 0) {
              permissions.forEach((item) => {
                if (item.module) {
                  can(
                    item.permission.code,
                    item.module ? item.module.code : ''
                  );
                }
              });
            }
          });
      }
      this.$store.commit('setRules', rules);
      this.$ability.update(rules);
    },

    async getOUDetails() {
      const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/company/${this.ouCode}`;
      await axios
        .get(url)
        .then((result) => {
          if (result.data.data) {
            localStorage.setItem('ouLogo', result.data.data.header_logo);
            this.$emit('ouSelected', result.data.data.header_logo);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },

    loadOU() {
      if (
        localStorage.getItem('ouAccess') == null ||
        localStorage.getItem('ouAccess').length === 0
      ) {
        fetchOUAccess();
      } else {
        this.$store.commit('getOUAccess');
      }
    },
    async fetchTaskCount() {
      try {
        const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/shared-tasks/my-count`;
        const res = await axios.get(url);
        this.taskCount = res.data?.count ?? 0;
        console.log('[TaskCount] response:', res.data);
      } catch (e) {
        console.error('[TaskCount] fetch failed:', e);
        this.taskCount = 0;
      }
    },
    async fetchTasks() {
      this.taskLoading = true;
      try {
        const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/shared-tasks`;
        const res = await axios.get(url, {
          params: { all: 'true', my: 1, status: 'New,In Progress,Pending,On Hold,Recurring' },
        });
        const list = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        this.tasks = list.map(this.mapTaskItem);
        this.syncTaskClockTimer();
      } catch (e) {
        console.warn('[Tasks] fetch failed:', e);
        this.tasks = [];
        this.syncTaskClockTimer();
      } finally {
        this.taskLoading = false;
      }
    },
    isTaskShowEligible(task) {
      const raw = task?._raw || task;
      if (!raw) return true;

      // If backend explicitly flagged show eligibility as false, hide it
      if (raw.is_show_eligible === false || raw.show_matched === false) {
        return false;
      }

      // Check notification triggers show condition
      const triggers = raw.notification_triggers || raw.notificationTriggers || [];
      if (Array.isArray(triggers) && triggers.length > 0) {
        const triggersWithShowCondition = triggers.filter(
          trg => trg && trg.trigger_show_module && trg.trigger_show_condition
        );
        if (triggersWithShowCondition.length > 0) {
          const anyMatched = triggersWithShowCondition.some(trg => trg.show_matched === true);
          const allExplicitlyFalse = triggersWithShowCondition.every(trg => trg.show_matched === false);
          if (allExplicitlyFalse && !anyMatched) {
            return false;
          }
        }
      }
      return true;
    },
    hasUpcomingTriggerCountdown() {
      const list = this.tasks || [];
      const now = this.currentTime || Date.now();

      for (const t of list) {
        const raw = t?._raw || t;
        if (!raw) continue;
        const status = String(raw.status || '').trim().toLowerCase();
        if (status === 'completed' || status === 'cancelled' || status === 'expired') continue;

        // Tasks whose trigger show condition is not met are not visible yet
        if (!this.isTaskShowEligible(raw)) continue;

        // Recurring tasks only countdown if there is an active 'New' recurring cycle
        if (raw.is_recurring) {
          const recs = raw.recurring_tasks || raw.recurringTasks || [];
          if (!recs.some(r => r.status === 'New')) continue;
        }

        // Check if task has extended_alarm_datetime in the future
        if (raw.extended_alarm_datetime) {
          const extMs = new Date(String(raw.extended_alarm_datetime).replace(' ', 'T')).getTime();
          if (!isNaN(extMs) && extMs > now) {
            return true;
          }
        }

        const triggers = raw.notification_triggers || raw.notificationTriggers || [];
        for (const trg of triggers) {
          if (!trg || trg.status_matched === false || trg.show_matched === false) continue;

          let dtStr = trg.computed_trigger_datetime;
          if (!dtStr && !trg.trigger_alert_module && !trg.trigger_alert_condition) {
            dtStr = trg.trigger_datetime;
          }
          if (!dtStr && trg.schedule_date) {
            const timePart = trg.schedule_time || '00:00:00';
            dtStr = `${trg.schedule_date} ${timePart}`;
          }
          if (!dtStr) continue;

          let str = String(dtStr).trim();
          if (/^\d{4}-\d{2}-\d{2}\s\d{2}:/.test(str)) {
            str = str.replace(' ', 'T');
          }

          let triggerTime = new Date(str);
          if (isNaN(triggerTime.getTime())) continue;

          if (!trg.computed_trigger_datetime && trg.trigger_timing) {
            triggerTime = this.applyTimingOffset(triggerTime, trg.trigger_timing);
          }

          // If trigger time is in the future, we have an active countdown to tick!
          if (triggerTime.getTime() > now) {
            return true;
          }
        }
      }
      return false;
    },
    syncTaskClockTimer() {
      const hasUpcoming = this.hasUpcomingTriggerCountdown();
      if (hasUpcoming) {
        // Start single general interval only if not already running
        if (!this.taskClockTimer) {
          this.taskClockTimer = setInterval(() => {
            this.currentTime = Date.now();
            this.checkAndPlayAlertSounds(false);
            if (!this.hasUpcomingTriggerCountdown()) {
              this.stopTaskClockTimer();
            }
          }, 1000);
        }
      } else {
        // Automatically turn off interval when no tasks need timing
        this.stopTaskClockTimer();
      }
    },
    stopTaskClockTimer() {
      if (this.taskClockTimer) {
        clearInterval(this.taskClockTimer);
        this.taskClockTimer = null;
      }
    },
    applyTimingOffset(dateObj, timingStr) {
      if (!timingStr || typeof timingStr !== 'string') return dateObj;
      const normalized = timingStr.trim().replace(/_/g, ' ').toLowerCase();
      if (normalized.includes('exact')) return dateObj;

      const match = normalized.match(/(\d+)\s*(minute|min|hour|hr|day|d)s?\s*(before|after)/i);
      if (!match) return dateObj;

      const amount = parseInt(match[1], 10);
      const unit = match[2].toLowerCase();
      const direction = match[3].toLowerCase();

      const copy = new Date(dateObj.getTime());
      let msOffset = 0;
      if (unit.startsWith('min')) {
        msOffset = amount * 60 * 1000;
      } else if (unit.startsWith('hour') || unit.startsWith('hr')) {
        msOffset = amount * 60 * 60 * 1000;
      } else if (unit.startsWith('day') || unit === 'd') {
        msOffset = amount * 24 * 60 * 60 * 1000;
      }

      if (direction === 'before') {
        copy.setTime(copy.getTime() - msOffset);
      } else {
        copy.setTime(copy.getTime() + msOffset);
      }
      return copy;
    },
    isTriggerActive(trigger, task = null) {
      if (!trigger) return false;

      // 0. Completed, Cancelled, or Expired tasks (case-insensitive) NEVER trigger pulse alerts
      const rawTask = task?._raw || task;
      const status = String(rawTask?.status || '').trim().toLowerCase();
      if (status === 'completed' || status === 'cancelled' || status === 'expired') return false;

      // If task show condition is not met yet, do not trigger alert
      if (rawTask && !this.isTaskShowEligible(rawTask)) return false;
      if (trigger.show_matched === false) return false;

      // Recurring tasks only alert if there is an active 'New' recurring cycle
      if (rawTask?.is_recurring) {
        const recs = rawTask.recurring_tasks || rawTask.recurringTasks || [];
        if (!recs.some(r => r.status === 'New')) return false;
      }

      // 1. If backend resolved status matching and it's false, condition is not met
      if (trigger.status_matched === false) return false;

      // 2. Alert type check
      let alertTypes = [];
      if (Array.isArray(trigger.alert_types)) {
        alertTypes = trigger.alert_types;
      } else if (typeof trigger.alert_types === 'string') {
        try {
          alertTypes = JSON.parse(trigger.alert_types);
        } catch (e) {
          alertTypes = trigger.alert_types ? trigger.alert_types.split(',').map(s => s.trim()) : [];
        }
      }

      let triggerTypes = [];
      if (Array.isArray(trigger.trigger_type)) {
        triggerTypes = trigger.trigger_type;
      } else if (typeof trigger.trigger_type === 'string') {
        triggerTypes = trigger.trigger_type.split(',').map(s => s.trim());
      }

      const isWebAlert = alertTypes.includes('web_alert') ||
                         triggerTypes.includes('web_notification') ||
                         alertTypes.length === 0;

      if (!isWebAlert) return false;

      // 3. Resolve trigger datetime (extended_alarm_datetime overrides if set)
      let dtStr = rawTask?.extended_alarm_datetime || trigger.computed_trigger_datetime;
      if (!dtStr && !trigger.trigger_alert_module && !trigger.trigger_alert_condition) {
        dtStr = trigger.trigger_datetime;
      }
      if (!dtStr && trigger.schedule_date) {
        const timePart = trigger.schedule_time || '00:00:00';
        dtStr = `${trigger.schedule_date} ${timePart}`;
      }

      if (!dtStr) return false;

      let str = String(dtStr).trim();
      if (/^\d{4}-\d{2}-\d{2}\s\d{2}:/.test(str)) {
        str = str.replace(' ', 'T');
      }

      let triggerTime = new Date(str);
      if (isNaN(triggerTime.getTime())) return false;

      // 4. Fallback timing offset application (only if not extended)
      if (!rawTask?.extended_alarm_datetime && !trigger.computed_trigger_datetime && trigger.trigger_timing) {
        triggerTime = this.applyTimingOffset(triggerTime, trigger.trigger_timing);
      }

      // 5. Compare with reactive current time
      const now = this.currentTime || Date.now();
      const isDue = now >= triggerTime.getTime();
      return isDue;
    },
    taskHasTriggerAlert(task) {
      const raw = task?._raw || task;
      if (!raw) return false;

      const status = String(raw.status || '').trim().toLowerCase();
      if (status === 'completed' || status === 'cancelled' || status === 'expired') return false;

      if (!this.isTaskShowEligible(raw)) return false;

      const triggers = raw.notification_triggers || raw.notificationTriggers;
      if (!Array.isArray(triggers) || !triggers.length) return false;

      return triggers.some(trg => this.isTriggerActive(trg, raw));
    },
    getTriggerCountdownInfo(task) {
      const raw = task?._raw || task;
      if (!raw) return null;
      const status = String(raw.status || '').trim().toLowerCase();
      if (status === 'completed' || status === 'cancelled' || status === 'expired') return null;

      if (!this.isTaskShowEligible(raw)) return null;

      // Recurring tasks only show countdown if there is an active 'New' recurring cycle
      if (raw.is_recurring) {
        const recs = raw.recurring_tasks || raw.recurringTasks || [];
        if (!recs.some(r => r.status === 'New')) return null;
      }

      const now = this.currentTime || Date.now();

      // If alarm was explicitly extended, check extended_alarm_datetime
      if (raw.extended_alarm_datetime) {
        let str = String(raw.extended_alarm_datetime).trim();
        if (/^\d{4}-\d{2}-\d{2}\s\d{2}:/.test(str)) str = str.replace(' ', 'T');
        let triggerTime = new Date(str);
        if (!isNaN(triggerTime.getTime())) {
          const diffMs = triggerTime.getTime() - now;
          if (diffMs <= 0) {
            return { isAlert: true, label: 'ALERT', text: 'Extended Alarm Active' };
          }
          const totalSec = Math.floor(diffMs / 1000);
          const hours = Math.floor(totalSec / 3600);
          const mins = Math.floor((totalSec % 3600) / 60);
          const secs = totalSec % 60;
          let timeStr = '';
          if (hours > 24) timeStr = `in ${Math.floor(hours / 24)}d ${hours % 24}h`;
          else if (hours > 0) timeStr = `in ${hours}h ${String(mins).padStart(2, '0')}m`;
          else if (mins > 0) timeStr = `in ${mins}m ${String(secs).padStart(2, '0')}s`;
          else timeStr = `in ${secs}s`;
          return { isAlert: false, label: timeStr, text: `Extended alarm countdown: ${timeStr}` };
        }
      }

      const triggers = raw.notification_triggers || raw.notificationTriggers || [];
      if (!Array.isArray(triggers) || !triggers.length) return null;

      let upcomingDiffMs = null;
      let activeTriggerFound = false;

      for (const trg of triggers) {
        if (!trg || trg.status_matched === false || trg.show_matched === false) continue;

        let dtStr = trg.computed_trigger_datetime;
        if (!dtStr && !trg.trigger_alert_module && !trg.trigger_alert_condition) {
          dtStr = trg.trigger_datetime;
        }
        if (!dtStr && trg.schedule_date) {
          const timePart = trg.schedule_time || '00:00:00';
          dtStr = `${trg.schedule_date} ${timePart}`;
        }
        if (!dtStr) continue;

        let str = String(dtStr).trim();
        if (/^\d{4}-\d{2}-\d{2}\s\d{2}:/.test(str)) {
          str = str.replace(' ', 'T');
        }

        let triggerTime = new Date(str);
        if (isNaN(triggerTime.getTime())) continue;

        if (!trg.computed_trigger_datetime && trg.trigger_timing) {
          triggerTime = this.applyTimingOffset(triggerTime, trg.trigger_timing);
        }

        const diffMs = triggerTime.getTime() - now;

        if (diffMs <= 0) {
          if (this.isTriggerActive(trg, raw)) {
            activeTriggerFound = true;
          }
        } else {
          if (upcomingDiffMs === null || diffMs < upcomingDiffMs) {
            upcomingDiffMs = diffMs;
          }
        }
      }

      if (activeTriggerFound) {
        return { isAlert: true, label: 'ALERT', text: 'Trigger Alert Active' };
      }

      if (upcomingDiffMs !== null) {
        const totalSec = Math.floor(upcomingDiffMs / 1000);
        const hours = Math.floor(totalSec / 3600);
        const mins = Math.floor((totalSec % 3600) / 60);
        const secs = totalSec % 60;

        let timeStr = '';
        if (hours > 24) {
          const days = Math.floor(hours / 24);
          timeStr = `in ${days}d ${hours % 24}h`;
        } else if (hours > 0) {
          timeStr = `in ${hours}h ${String(mins).padStart(2, '0')}m`;
        } else if (mins > 0) {
          timeStr = `in ${mins}m ${String(secs).padStart(2, '0')}s`;
        } else {
          timeStr = `in ${secs}s`;
        }

        return { isAlert: false, label: timeStr, text: `Trigger countdown: ${timeStr}` };
      }

      return null;
    },
    mapTaskItem(row) {
      const recurringList = Array.isArray(row.recurring_tasks || row.recurringTasks)
        ? (row.recurring_tasks || row.recurringTasks)
        : [];
      const activeRecurring = recurringList.filter(r => r.status === 'New');
      const latestRec = activeRecurring.length ? activeRecurring[0] : (recurringList.length ? recurringList[0] : null);

      return {
        id: row.id,
        title: row.title,
        description: row.description || '',
        module: row.module,
        module_reference: row.module_reference,
        is_recurring: !!row.is_recurring,
        extended_alarm_datetime: row.extended_alarm_datetime,
        recurring_module: latestRec ? latestRec.module : null,
        recurring_reference: latestRec ? latestRec.reference : null,
        recurring_tasks: recurringList,
        priority: row.priority,
        status: row.status,
        requested_by_name: row.requested_by
          ? `${row.requested_by.firstname || ''} ${row.requested_by.lastname || ''}`.trim() || '—'
          : '—',
        due_date: row.due_date,
        created_at: row.created_at,
        is_show_eligible: row.is_show_eligible !== undefined ? row.is_show_eligible : (row.show_matched !== undefined ? row.show_matched : true),
        show_matched: row.show_matched !== undefined ? row.show_matched : (row.is_show_eligible !== undefined ? row.is_show_eligible : true),
        notification_triggers: row.notification_triggers || row.notificationTriggers || [],
        _raw: row,
      };
    },
    goToTasks() {
      this.$router.push({ path: '/my-shared-tasks', query: { view: 'assigned' } });
    },
    isTaskAutoCompleted(task) {
      if (!task) return false;
      const raw = task._raw || task;
      if (raw.is_recurring) return true;
      const triggers = raw.notification_triggers || raw.notificationTriggers || [];
      return Array.isArray(triggers) && triggers.some(t => !!(t && t.trigger_completed_status && String(t.trigger_completed_status).trim()));
    },
    async handleTaskCheckboxClick(task) {
      if (!task) return;
      const raw = task._raw || task;
      if (this.isTaskAutoCompleted(raw)) {
        this.viewTask(raw);
        return;
      }
      // For basic tasks without auto-completion: quick toggle status
      const newStatus = raw.status === 'Completed' ? 'In Progress' : 'Completed';
      const prevStatus = raw.status;
      raw.status = newStatus;
      if (task !== raw) task.status = newStatus;
      try {
        const BASE = process.env.VUE_APP_AUTHDOMAIN;
        await axios.post(`${BASE}/api/v1/shared-tasks/${raw.id}/update`, {
          status: newStatus,
        });
        this.fetchTaskCount();
        this.fetchTasks();
      } catch (e) {
        console.error('Failed to update task status from nav-bar:', e);
        raw.status = prevStatus;
        if (task !== raw) task.status = prevStatus;
      }
    },
    handleTaskClick(task) {
      this.viewTask(task);
    },
    viewTask(data) {
      if (!data) return;
      const task = data._raw || data;
      if (!task) return;
      const recurringList = Array.isArray(task.recurring_tasks || task.recurringTasks)
        ? (task.recurring_tasks || task.recurringTasks)
        : [];
      const activeRec = recurringList.find(r => r.status === 'New') || recurringList[0] || null;
      const recModule = task.recurring_module || activeRec?.module;
      const recRef = task.recurring_reference || activeRec?.reference;
      const isRec = task.is_recurring || !!recModule || !!recRef;
      const triggers = task.notification_triggers || task.notificationTriggers || [];
      const autoCompTrigger = (Array.isArray(triggers) ? triggers : []).find(t => {
        return !!(t && t.trigger_completed_status && String(t.trigger_completed_status).trim());
      });
      const canManualUpdate = !isRec && !autoCompTrigger;

      const responsibles = task.responsibles || [];
      const responsibleItems = responsibles.map(r => {
        const entity = r.responsible;
        if (!entity) return null;
        const type = r.responsible_type?.includes('User') ? 'User'
          : r.responsible_type?.includes('Department') ? 'Dept'
            : r.responsible_type?.includes('Role') ? 'Role' : '';
        const name = entity.fullname || entity.name || entity.department_name || '—';
        const initials = name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
        const icon = type === 'User' ? 'ri-user-3-line' : type === 'Dept' ? 'ri-building-2-line' : 'ri-shield-user-line';
        return { name, type, initials, icon };
      }).filter(Boolean);

      // Compute due status
      const dueDiff = task.due_date ? Math.ceil((new Date(task.due_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
      const dueClass = dueDiff === null ? '' : dueDiff < 0 ? 'tp-due-overdue' : dueDiff === 0 ? 'tp-due-today' : dueDiff <= 2 ? 'tp-due-soon' : 'tp-due-ok';
      const dueText = dueDiff === null ? '' : dueDiff < 0 ? `${Math.abs(dueDiff)}d overdue` : dueDiff === 0 ? 'Due today' : dueDiff === 1 ? '1 day left' : `${dueDiff} days left`;

      // Status config
      const statusConfig = {
        'New': { cls: 'tp-st-new', icon: 'ri-sparkling-line', gradient: '#111111' },
        'In Progress': { cls: 'tp-st-progress', icon: 'ri-loader-4-line', gradient: '#111111' },
        'Pending': { cls: 'tp-st-pending', icon: 'ri-time-line', gradient: '#111111' },
        'On Hold': { cls: 'tp-st-hold', icon: 'ri-pause-circle-line', gradient: '#111111' },
        'Completed': { cls: 'tp-st-completed', icon: 'ri-checkbox-circle-line', gradient: '#111111' },
        'Cancelled': { cls: 'tp-st-cancelled', icon: 'ri-close-circle-line', gradient: '#111111' },
        'Recurring': { cls: 'tp-st-new', icon: 'ri-repeat-2-line', gradient: '#111111' },
      };
      const sc = statusConfig[task.status] || statusConfig['New'];

      // Priority config
      const priConfig = {
        'Low': { cls: 'tp-pri-low', icon: 'ri-arrow-down-line' },
        'Medium': { cls: 'tp-pri-medium', icon: 'ri-subtract-line' },
        'High': { cls: 'tp-pri-high', icon: 'ri-arrow-up-line' },
        'Urgent': { cls: 'tp-pri-urgent', icon: 'ri-fire-line' },
      };
      const pc = priConfig[task.priority] || priConfig['Medium'];

      // Timeline steps
      const steps = ['New', 'In Progress', 'Completed'];
      const currentIdx = task.status === 'Completed' ? 2 : task.status === 'In Progress' ? 1 : task.status === 'Cancelled' ? -1 : 0;

      // Alarm status & computation
      const isAlertRunning = this.taskHasTriggerAlert(task);
      const nextTriggerMs = (() => {
        if (task.extended_alarm_datetime) {
          const extMs = new Date(String(task.extended_alarm_datetime).replace(' ', 'T')).getTime();
          if (!isNaN(extMs)) return extMs;
        }
        const triggers = task.notification_triggers || task.notificationTriggers || [];
        const times = triggers
          .filter(t => t && t.trigger_datetime)
          .map(t => new Date(String(t.trigger_datetime).replace(' ', 'T')).getTime())
          .filter(t => !isNaN(t))
          .sort((a, b) => a - b);
        return times.length ? times[0] : null;
      })();
      const alarmStatusHtml = isAlertRunning
        ? '<span class="badge bg-danger text-white fs-11 px-2 py-1 pulse-alert-badge me-2"><i class="ri-notification-3-fill me-1"></i>ALERT RUNNING</span> <span class="text-danger fw-semibold">Alarm condition reached and currently ringing</span>'
        : (task.extended_alarm_datetime
          ? `Alarm extended to: <strong class="text-dark">${this.formatDateTime(task.extended_alarm_datetime)}</strong>`
          : (nextTriggerMs
            ? `Next alarm: <strong class="text-dark">${new Date(nextTriggerMs).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}</strong>`
            : '<span class="tp-empty">No active alarm</span>'));

      const displayModule = (isRec && (recModule || recRef)) ? recModule : task.module;
      const displayRef = (isRec && (recModule || recRef)) ? recRef : task.module_reference;

      Swal.fire({
        width: 680,
        padding: '0',
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true,
        customClass: {
          container: 'task-view-swal-container',
          popup: 'task-view-swal-popup',
          closeButton: 'tp-close-btn',
        },
        title: '',
        html: `
          <div class="tp-modal">

            <!-- ═══ Premium Hero Header ═══ -->
            <div class="tp-hero" style="background: ${sc.gradient};">
              <div class="tp-hero-pattern"></div>
              <div class="tp-hero-content">
                <div class="tp-hero-top">
                  <span class="tp-hero-id">#${task.id || '—'}</span>
                  <span class="tp-hero-status-pill ${sc.cls}">
                    <i class="${sc.icon}"></i> ${task.status || '—'}
                  </span>
                </div>
                <h4 class="tp-hero-title">${task.title || 'Untitled Task'}</h4>
                <div class="tp-hero-meta">
                  <span class="tp-hero-chip"><i class="ri-apps-2-line"></i> ${displayModule || '—'}</span>
                  ${displayRef ? `<span class="tp-hero-chip tp-hero-chip-ref"><i class="ri-hashtag"></i> ${displayRef}</span>` : ''}
                  ${isRec && task.module ? `<span class="tp-hero-chip"><i class="ri-git-merge-line"></i> Origin: ${task.module} ${task.module_reference ? '#' + task.module_reference : ''}</span>` : ''}
                  <span class="tp-hero-chip ${pc.cls}"><i class="${pc.icon}"></i> ${task.priority || '—'}</span>
                  ${dueText ? `<span class="tp-hero-chip ${dueClass}"><i class="ri-calendar-check-line"></i> ${dueText}</span>` : ''}
                </div>
              </div>
            </div>

            <!-- ═══ Timeline Progress ═══ -->
            <div class="tp-timeline-bar">
              ${steps.map((s, i) => `
                <div class="tp-tl-step ${i <= currentIdx ? 'tp-tl-active' : ''} ${i === currentIdx ? 'tp-tl-current' : ''} ${task.status === 'Cancelled' ? 'tp-tl-cancelled' : ''}">
                  <div class="tp-tl-dot"><i class="${i === 0 ? 'ri-play-circle-line' : i === 1 ? 'ri-loader-4-line' : 'ri-checkbox-circle-line'}"></i></div>
                  <span class="tp-tl-label">${s}</span>
                </div>
                ${i < steps.length - 1 ? `<div class="tp-tl-connector ${i < currentIdx ? 'tp-tl-conn-active' : ''}"></div>` : ''}
              `).join('')}
            </div>

            <!-- ═══ Body Content ═══ -->
            <div class="tp-body">

              <!-- Info Cards Row -->
              <div class="tp-info-cards">
                <div class="tp-info-card">
                  <div class="tp-info-card-icon" style="background: rgba(167,43,43,0.08); color: #a72b2b;"><i class="ri-user-star-line"></i></div>
                  <div class="tp-info-card-body">
                    <span class="tp-info-card-label">Requested By</span>
                    <span class="tp-info-card-value">${((task.requested_by?.firstname || '') + ' ' + (task.requested_by?.lastname || '')).trim() || '—'}</span>
                  </div>
                </div>
                <div class="tp-info-card">
                  <div class="tp-info-card-icon" style="background: rgba(30,30,30,0.06); color: #1f2937;"><i class="ri-calendar-event-line"></i></div>
                  <div class="tp-info-card-body">
                    <span class="tp-info-card-label">Due Date</span>
                    <span class="tp-info-card-value">${task.due_date ? new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : 'No due date'}</span>
                  </div>
                </div>
                <div class="tp-info-card">
                  <div class="tp-info-card-icon" style="background: rgba(167,43,43,0.06); color: #c94444;"><i class="ri-time-line"></i></div>
                  <div class="tp-info-card-body">
                    <span class="tp-info-card-label">Created</span>
                    <span class="tp-info-card-value">${task.created_at ? new Date(task.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '—'}</span>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <div class="tp-card">
                <div class="tp-card-header">
                  <i class="ri-file-text-line"></i>
                  <span>Description</span>
                </div>
                <div class="tp-card-body tp-desc-body">
                  ${task.description || '<span class="tp-empty">No description provided</span>'}
                </div>
              </div>

              <!-- Responsibles -->
              <div class="tp-card">
                <div class="tp-card-header">
                  <i class="ri-team-line"></i>
                  <span>Assigned To</span>
                  <span class="tp-card-count">${responsibleItems.length}</span>
                </div>
                <div class="tp-card-body">
                  ${responsibleItems.length > 0 ? `
                  <div class="tp-resp-list">
                    ${responsibleItems.map(r => `
                      <div class="tp-resp-item">
                        <div class="tp-resp-avatar"><i class="${r.icon}"></i></div>
                        <div class="tp-resp-info">
                          <span class="tp-resp-name">${r.name}</span>
                          <span class="tp-resp-type">${r.type}</span>
                        </div>
                      </div>
                    `).join('')}
                  </div>` : '<span class="tp-empty">No assignees</span>'}
                </div>
              </div>

              <!-- Update Section (Exclusive for Manual Tasks) -->
              ${canManualUpdate ? `
              <div class="tp-card tp-card-update">
                <div class="tp-card-header tp-card-header-action">
                  <i class="ri-edit-box-line"></i>
                  <span>Update Task</span>
                </div>
                <div class="tp-card-body">
                  <div class="tp-form-grid">
                    <div class="tp-form-group">
                      <label class="tp-form-label"><i class="ri-toggle-line"></i> Status</label>
                      <select id="tsk-status-select" class="tp-form-select">
                        <option value="New" ${task.status === 'New' ? 'selected' : ''}>New</option>
                        <option value="In Progress" ${task.status === 'In Progress' ? 'selected' : ''}>In Progress</option>
                        <option value="Pending" ${task.status === 'Pending' ? 'selected' : ''}>Pending</option>
                        <option value="On Hold" ${task.status === 'On Hold' ? 'selected' : ''}>On Hold</option>
                        <option value="Completed" ${task.status === 'Completed' ? 'selected' : ''}>Completed</option>
                        <option value="Cancelled" ${task.status === 'Cancelled' ? 'selected' : ''}>Cancelled</option>
                      </select>
                    </div>
                    <div class="tp-form-group tp-form-full">
                      <label class="tp-form-label"><i class="ri-chat-3-line"></i> Remarks</label>
                      <textarea id="tsk-remarks-input" class="tp-form-textarea" rows="3" placeholder="Write your remarks here...">${task.remarks || ''}</textarea>
                    </div>
                  </div>
                </div>
                <div class="tp-card-footer">
                  <span id="tsk-update-msg" class="tp-update-msg"></span>
                  <button id="tsk-save-btn" class="tp-save-btn" data-id="${task.id}">
                    <i class="ri-save-line"></i> Save Changes
                  </button>
                </div>
              </div>` : `
              ${task.remarks ? `
              <div class="tp-card">
                <div class="tp-card-header">
                  <i class="ri-chat-1-line"></i>
                  <span>Remarks</span>
                </div>
                <div class="tp-card-body tp-desc-body">
                  ${task.remarks}
                </div>
              </div>` : ''}
              <div class="tp-card tp-card-notice">
                <div class="tp-card-body d-flex align-items-center gap-3">
                  <div class="tp-notice-icon">
                    <i class="ri-information-line"></i>
                  </div>
                  <span class="tp-notice-text">${isRec ? 'This is an automated recurring task. Status and cycles are managed automatically.' : (autoCompTrigger ? `This task has auto-completion enabled: status will automatically complete when <strong>${autoCompTrigger.trigger_completed_module || task.module || 'the module'}</strong> status is updated to <strong>${autoCompTrigger.trigger_completed_status}</strong>.` : 'This is a basic task. Status can be updated manually.')}</span>
                </div>
              </div>`}

              <!-- Notification Alarm Section -->
              <div class="tp-card tp-card-alarm">
                <div class="tp-card-header">
                  <i class="ri-notification-3-line"></i>
                  <span>Notification Alarm</span>
                  ${isAlertRunning ? '<span class="tp-alarm-ringing-badge"><i class="ri-alarm-warning-line"></i> Ringing</span>' : ''}
                </div>
                <div class="tp-card-body">
                  <div class="tp-alarm-status-box">
                    ${alarmStatusHtml}
                  </div>
                  ${isAlertRunning ? `
                  <div class="tp-alarm-extend-box">
                    <span class="tp-alarm-label"><i class="ri-time-line"></i> Extend Alarm</span>
                    <div class="tp-pill-group">
                      <button type="button" class="tp-alarm-pill" data-offset="30" title="Extend alarm by 30 minutes">30m</button>
                      <button type="button" class="tp-alarm-pill" data-offset="60" title="Extend alarm by 1 hour">1h</button>
                      <button type="button" class="tp-alarm-pill" data-offset="120" title="Extend alarm by 2 hours">2h</button>
                      <button type="button" class="tp-alarm-pill" data-offset="360" title="Extend alarm by 6 hours">6h</button>
                      <button type="button" class="tp-alarm-pill" data-offset="720" title="Extend alarm by 12 hours">12h</button>
                      <button type="button" class="tp-alarm-pill" data-offset="1440" title="Extend alarm by 24 hours">24h</button>
                    </div>
                  </div>
                  <div class="tp-alarm-hint">
                    <i class="ri-information-line"></i> Extend snoozes the alarm to fire in the future.
                  </div>` : ''}
                </div>
                ${isAlertRunning ? `
                <div class="tp-card-footer tp-alarm-footer">
                  <span id="tsk-alarm-msg" class="tp-alarm-msg"></span>
                  <button id="tsk-alarm-off-btn" class="tp-alarm-off-btn" type="button" title="Turn off the notification alarm">
                    <i class="ri-notification-off-line"></i> Turn Off Alarm
                  </button>
                </div>` : ''}
              </div>

            </div>
          </div>
        `,
        didOpen: () => {
          const taskId = task.id;

          const saveBtn = document.getElementById('tsk-save-btn');
          if (saveBtn) {
            saveBtn.addEventListener('click', async () => {
              const status = document.getElementById('tsk-status-select')?.value;
              const remarks = document.getElementById('tsk-remarks-input')?.value;
              const msgEl = document.getElementById('tsk-update-msg');

              if (!msgEl) return;
              msgEl.textContent = '';
              saveBtn.disabled = true;
              saveBtn.innerHTML = '<span class="tp-spinner"></span> Saving...';

              try {
                const BASE = process.env.VUE_APP_AUTHDOMAIN;
                const res = await axios.post(BASE + '/api/v1/shared-tasks/' + taskId + '/update', {
                  status,
                  remarks,
                });

                if (res.status === 200) {
                  msgEl.className = 'tp-update-msg tp-msg-success';
                  msgEl.innerHTML = '<i class="ri-checkbox-circle-line"></i> Task updated successfully!';

                  // Refresh tasks and count
                  this.fetchTaskCount();
                  this.fetchTasks();

                  // Close after short delay
                  setTimeout(() => Swal.close(), 1200);
                }
              } catch (e) {
                msgEl.className = 'tp-update-msg tp-msg-error';
                msgEl.innerHTML = '<i class="ri-error-warning-line"></i> ' + (e.response?.data?.message || 'Update failed');
                saveBtn.disabled = false;
                saveBtn.innerHTML = '<i class="ri-save-line"></i> Save Changes';
              }
            });
          }

          // ---- Alarm / Notification controls ----
          const offBtn = document.getElementById('tsk-alarm-off-btn');

          document.querySelectorAll('.tp-alarm-pill').forEach((btn) => {
            btn.addEventListener('click', async () => {
              const offsetMin = parseInt(btn.dataset.offset, 10) || 0;
              await this.updateTaskAlarm(taskId, offsetMin);
            });
          });

          if (offBtn) {
            offBtn.addEventListener('click', async () => {
              await this.updateTaskAlarm(taskId, 0);
            });
          }
        },
      });
    },
    // Extend (snooze) or turn off a task's notification alarm.
    // offsetMin > 0  -> set extended_alarm_datetime offsetMin minutes from now.
    // offsetMin === 0 -> reset extended_alarm_datetime to null.
    async updateTaskAlarm(taskId, offsetMin) {
      const msgEl = document.getElementById('tsk-alarm-msg');
      const setMsg = (ok, text) => {
        if (!msgEl) return;
        msgEl.className = ok ? 'tp-alarm-msg tp-msg-success' : 'tp-alarm-msg tp-msg-error';
        msgEl.innerHTML = (ok ? '<i class="ri-checkbox-circle-line"></i> ' : '<i class="ri-error-warning-line"></i> ') + text;
      };

      if (msgEl) {
        msgEl.className = 'tp-alarm-msg text-muted';
        msgEl.innerHTML = '<span class="tp-spinner" style="border-color: rgba(0,0,0,0.2); border-top-color: #a72b2b;"></span> Extending...';
      }

      try {
        const BASE = process.env.VUE_APP_AUTHDOMAIN;

        let extended_alarm_datetime = null;
        if (offsetMin > 0) {
          const dt = new Date(Date.now() + offsetMin * 60 * 1000);
          const pad = n => String(n).padStart(2, '0');
          extended_alarm_datetime = `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:00`;
        }

        const res = await axios.post(`${BASE}/api/v1/shared-tasks/${taskId}/update`, {
          extended_alarm_datetime,
        });

        if (res.status === 200) {
          this.fetchTaskCount();
          this.fetchTasks();
          setMsg(true, offsetMin > 0 ? 'Alarm extended!' : 'Alarm reset.');
          setTimeout(() => Swal.close(), 1000);
        }
      } catch (e) {
        setMsg(false, e.response?.data?.message || 'Update failed');
      }
    },
    /* ---------------- task alert sound (bell ring) ---------------- */
    // Play a short synthesized "bell" when a task's web-alert trigger becomes
    // active. Uses the Web Audio API so no audio asset is required.
    playAlertSound() {
      if (!this.alertSoundEnabled) return;
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        if (!this.audioCtx) this.audioCtx = new AudioCtx();
        const ctx = this.audioCtx;
        if (ctx.state === 'suspended') ctx.resume();

        const now = ctx.currentTime;
        const ding = (freq, start, dur, peak) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'sine';
          osc.frequency.value = freq;
          gain.gain.setValueAtTime(0.0001, start);
          gain.gain.linearRampToValueAtTime(peak, start + 0.01);
          gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.start(start);
          osc.stop(start + dur + 0.05);
        };

        // Bell-like "ding-dong": fundamental + harmonic + a soft echo strike.
        ding(1174.66, now, 1.0, 0.28);        // D6
        ding(2349.32, now, 0.6, 0.07);        // D7 overtone
        ding(587.33, now, 1.0, 0.12);         // D5 body
        ding(1174.66, now + 0.45, 1.1, 0.18); // echo strike
        ding(587.33, now + 0.45, 1.1, 0.08);
      } catch (e) {
        console.warn('[Alert] Could not play sound:', e);
      }
    },
    // Play alert sound if any task has an active trigger alert.
    // Passes initial=true on initial load to prevent playing immediately on page refresh.
    checkAndPlayAlertSounds(initial = false) {
      if (initial) {
        (this.tasks || []).forEach(t => {
          if (this.taskHasTriggerAlert(t)) {
            this.alertedTaskIds.add(t.id);
          }
        });
        return;
      }
      let shouldRing = false;
      (this.tasks || []).forEach(t => {
        if (this.taskHasTriggerAlert(t)) {
          if (!this.alertedTaskIds.has(t.id)) {
            this.alertedTaskIds.add(t.id);
            shouldRing = true;
          }
        } else {
          this.alertedTaskIds.delete(t.id);
        }
      });
      if (shouldRing) {
        this.playAlertSound();
      }
    },
    toggleAlertSound() {
      this.alertSoundEnabled = !this.alertSoundEnabled;
      try {
        localStorage.setItem('taskAlertSound', this.alertSoundEnabled ? '1' : '0');
      } catch (e) {
        // Ignore storage write failures (private mode, quota, etc.).
      }
    },
    shortDesc(desc, maxLen = 75) {
      if (!desc) return '';
      const plain = String(desc).replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
      if (plain.length <= maxLen) return plain;
      return plain.slice(0, maxLen) + '...';
    },
    // Returns { label, badgeClass, listClass } for a task's due datetime, or
    // null when there is no due date. The badge is time-aware:
    //  - Date-only tasks (stored with a 00:00:00 time) are due for the whole
    //    of that calendar day, so they only become overdue the next day.
    //  - Tasks with a specific time are compared against the current time, so
    //    a task whose due time has already passed shows as overdue even if the
    //    due date is still "today".
    getDueInfo(dueDate) {
      if (!dueDate) return null;
      const due = new Date(String(dueDate).replace(' ', 'T'));
      if (isNaN(due.getTime())) return null;
      const now = new Date();

      const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      const dayDiff = Math.round((startOf(due) - startOf(now)) / (1000 * 60 * 60 * 24));

      const onlyDate = due.getHours() === 0 && due.getMinutes() === 0 && due.getSeconds() === 0;
      const overdue = onlyDate
        ? startOf(due) < startOf(now)
        : due.getTime() < now.getTime();

      if (overdue) {
        const days = Math.abs(dayDiff);
        return {
          label: days > 0 ? `${days}d overdue` : 'Overdue today',
          badgeClass: 'tsk-due-overdue',
          listClass: 'bg-soft-danger text-danger',
        };
      }
      if (dayDiff === 0) {
        return { label: 'Due today', badgeClass: 'tsk-due-today', listClass: 'bg-soft-warning text-warning' };
      }
      if (dayDiff === 1) {
        return { label: '1 day left', badgeClass: 'tsk-due-soon', listClass: 'bg-soft-warning text-warning' };
      }
      if (dayDiff <= 2) {
        return { label: `${dayDiff} days left`, badgeClass: 'tsk-due-soon', listClass: 'bg-soft-warning text-warning' };
      }
      return { label: `${dayDiff} days left`, badgeClass: 'tsk-due-ok', listClass: 'bg-soft-secondary text-secondary' };
    },
    // Relative time for a task's created_at, e.g. "just now", "20 mins ago",
    // "1 hour ago", "2 days ago".
    timeAgo(dateStr) {
      if (!dateStr) return '';
      const date = new Date(String(dateStr).replace(' ', 'T'));
      if (isNaN(date.getTime())) return '';

      const seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
      if (seconds < 60) return 'just now';

      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes} min${minutes > 1 ? 's' : ''} ago`;

      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;

      const days = Math.floor(hours / 24);
      if (days < 30) return `${days} day${days > 1 ? 's' : ''} ago`;

      const months = Math.floor(days / 30);
      if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`;

      const years = Math.floor(months / 12);
      return `${years} year${years > 1 ? 's' : ''} ago`;
    },
    // Format a backend datetime (Y-m-d H:i:s) as e.g. "Aug 4, 2026, 9:30 AM".
    formatDateTime(dateStr) {
      if (!dateStr) return '—';
      const d = new Date(String(dateStr).replace(' ', 'T'));
      if (isNaN(d.getTime())) return '—';
      return d.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
    },
    // Format a backend datetime as its time portion, e.g. "5:00 PM".
    formatTime(dateStr) {
      if (!dateStr) return '—';
      const d = new Date(String(dateStr).replace(' ', 'T'));
      if (isNaN(d.getTime())) return '—';
      return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    },
    listenForTasks() {
      const userId = localStorage.getItem('userid');
      if (!userId) return;

      const echoInstance = getEcho();
      if (!echoInstance) return;

      echoInstance.connector.options.auth.headers.Authorization =
        `Bearer ${localStorage.getItem('jwt')}`;

      echoInstance
        .private(`App.Models.User.${userId}`)
        .listen('.TaskEvent', (e) => {
          console.log('[Echo] Task event received:', e);

          // Refresh the count and full task data from API
          // (Echo payload doesn't include nested relations like
          //  responsibles / requested_by, so we must re-fetch)
          this.fetchTaskCount();
          this.fetchTasks().then(() => this.checkAndPlayAlertSounds(false));
        });
    },
    stopListeningForTasks() {
      const userId = localStorage.getItem('userid');
      if (userId) {
        const echoInstance = getEcho();
        if (echoInstance) {
          echoInstance.leave(`App.Models.User.${userId}`);
        }
      }
    },
    loadActiveOU() {
      this.$store.commit('getActiveOU');
      // if (localStorage.getItem('activeOU') == null || localStorage.getItem('activeOU').length===0)
      // {
      //     fetchOUAccess();
      // }
      // else
      // {
      // }
    },

    toggleHamburgerMenu() {
      var windowSize = document.documentElement.clientWidth;
      let layoutType = document.documentElement.getAttribute('data-layout');
      let visiblilityType = document.documentElement.getAttribute(
        'data-sidebar-visibility'
      );
      if (windowSize > 767)
        document.querySelector('.hamburger-icon').classList.toggle('open');

      //For collapse horizontal menu
      if (
        document.documentElement.getAttribute('data-layout') === 'horizontal'
      ) {
        document.body.classList.contains('menu')
          ? document.body.classList.remove('menu')
          : document.body.classList.add('menu');
      }

      //For collapse vertical menu

      if (
        visiblilityType === 'show' &&
        (layoutType === 'vertical' || layoutType === 'semibox')
      ) {
        if (windowSize < 1025 && windowSize > 767) {
          document.body.classList.remove('vertical-sidebar-enable');
          document.documentElement.getAttribute('data-sidebar-size') == 'sm'
            ? document.documentElement.setAttribute('data-sidebar-size', '')
            : document.documentElement.setAttribute('data-sidebar-size', 'sm');
        } else if (windowSize > 1025) {
          document.body.classList.remove('vertical-sidebar-enable');
          const next = document.documentElement.getAttribute('data-sidebar-size') == 'lg' ? 'sm' : 'lg';
          document.documentElement.setAttribute('data-sidebar-size', next);
          // Persist via the store (CHANGE_SIDEBAR_TYPE writes localStorage) so the
          // collapse survives a refresh instead of resetting to 'lg'.
          this.$store.commit('layout/CHANGE_SIDEBAR_TYPE', next);
        } else if (windowSize <= 767) {
          document.body.classList.add('vertical-sidebar-enable');
          document.documentElement.setAttribute('data-sidebar-size', 'lg');
        }
      }

      //Two column menu
      if (document.documentElement.getAttribute('data-layout') == 'twocolumn') {
        document.body.classList.contains('twocolumn-panel')
          ? document.body.classList.remove('twocolumn-panel')
          : document.body.classList.add('twocolumn-panel');
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle('fullscreen-enable');
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      document.getElementById('header-lang-img').setAttribute('src', flag);
      i18n.global.locale = locale;
    },
    toggleDarkMode() {
      if (document.documentElement.getAttribute('data-layout-mode') == 'dark') {
        document.documentElement.setAttribute('data-layout-mode', 'light');
      } else {
        document.documentElement.setAttribute('data-layout-mode', 'dark');
      }
    },
    initTopbarComponents() {
      // notification messages
      if (document.getElementsByClassName('notification-check')) {
        Array.from(
          document.querySelectorAll('.notification-check input')
        ).forEach(function (element) {
          element.addEventListener('click', function (el) {
            el.target.closest('.notification-item').classList.toggle('active');
          });
        });
      }
    },

    onSearchInput() {
      this.activeIndex = -1;
      clearTimeout(this.searchTimer);

      if (this.searchQuery.length > 2) {
        this.searchLoading = true;
        this.searchDropdownOpen = true;
        this.searchTimer = setTimeout(() => {
          this.initSearch(this.searchQuery);
        }, 300);
      } else {
        this.searchDropdownOpen = false;
        this.suggested_menu = [];
        this.otherDocuments = [];
      }
    },

    onFocusSearch() {
      if (this.searchQuery.length > 0) {
        this.searchDropdownOpen = true;
      }
    },

    clearSearch() {
      this.searchQuery = '';
      this.searchDropdownOpen = false;
      this.suggested_menu = [];
      this.otherDocuments = [];
      this.searchUsers = [];
      this.searchCustomers = [];
      this.searchBookings = [];
      this.searchCsr = [];
      this.activeIndex = -1;
    },

    handleKeydown(e) {
      const totalItems = this.totalResults;
      if (!this.searchDropdownOpen || totalItems === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.activeIndex = this.activeIndex < totalItems - 1 ? this.activeIndex + 1 : 0;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : totalItems - 1;
      } else if (e.key === 'Enter' && this.activeIndex >= 0) {
        e.preventDefault();
        this.navigateActive();
      } else if (e.key === 'Escape') {
        this.searchDropdownOpen = false;
      }
    },

    navigateActive() {
      const allItems = this.allResultItems;
      if (allItems[this.activeIndex]) {
        const item = allItems[this.activeIndex];
        this.searchDropdownOpen = false;
        if (item.url) {
          this.$router.push(item.url);
        } else if (item.generated_url) {
          this.$router.push(item.generated_url);
        }
      }
    },


    async initSearch(q) {
      this.searchLoading = true;
      const query = q.toLowerCase();

      const menus = this.$store.state.menus || [];
      const results = [];
      this.searchMenuRecursive(menus, query, results);
      this.suggested_menu = results.slice(0, this.searchLimit);

      const userId = localStorage.getItem('userid');
      const ou = localStorage.getItem('activeOU');
      const apiBase = process.env.VUE_APP_AUTHDOMAIN;

      const [usersRes, customersRes, bookingsRes, csrRes] = await Promise.allSettled([
        axios.post(`${apiBase}/api/v1/get_users`, { search: q, simple: true, limit: 5 }),
        axios.get(`${apiBase}/api/v1/customer`, { params: { keyword: q, per_page: 5 } }),
        axios.get(`${apiBase}/api/v1/get_booking_list`, { params: { user_id: userId, ou: ou, startRow: 0, endRow: 5, filterModel: JSON.stringify({ customer_name: { filterType: 'text', filter: q } }) } }),
        axios.get(`${apiBase}/api/v1/csr/get_csr`, { params: { csr_reference: q, startRow: 0, endRow: 5 } }),
      ]);

      this.searchUsers = usersRes.status === 'fulfilled' ? (usersRes.value.data.data || []).slice(0, this.searchLimit) : [];
      this.searchCustomers = customersRes.status === 'fulfilled' ? (customersRes.value.data.data || []).slice(0, this.searchLimit) : [];
      this.searchBookings = bookingsRes.status === 'fulfilled' ? (bookingsRes.value.data.data || []).slice(0, this.searchLimit) : [];
      this.searchCsr = csrRes.status === 'fulfilled' ? (csrRes.value.data.data || []).slice(0, this.searchLimit) : [];

      this.otherDocuments = [];
      this.searchLoading = false;
    },

    searchMenuRecursive(menus, query, results) {
      if (!Array.isArray(menus)) return;

      for (const menu of menus) {
        if (!menu) continue;

        if (menu.name && menu.name.toLowerCase().includes(query)) {
          results.push({
            name: menu.name,
            url: '/' + menu.url,
            icon: menu.icon,
            children: [],
          });
        }

        if (menu.children && menu.children.length > 0) {
          this.searchMenuRecursive(menu.children, query, results);
        }
      }
    },

    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.searchDropdownOpen = false;
      }
    },
  },
  computed: {
    ouAccess() {
      return this.$store.state.ouAccess;
    },
    ouCode() {
      return this.$store.state.activeOU;
    },
    rules() {
      return this.$store.state.rules;
    },
    totalResults() {
      return (
        this.suggested_menu.length +
        this.searchUsers.length +
        this.searchCustomers.length +
        this.searchBookings.length +
        this.searchCsr.length
      );
    },
    allResultItems() {
      const items = [];
      this.suggested_menu.forEach(menu => {
        items.push({ url: '/' + menu.url, type: 'menu' });
      });
      this.searchUsers.forEach(user => {
        items.push({ url: '/user-management/users', type: 'user' });
      });
      this.searchCustomers.forEach(cust => {
        items.push({ url: '/customers/customers_list', type: 'customer' });
      });
      this.searchBookings.forEach(bk => {
        items.push({ url: '/booking', type: 'booking' });
      });
      this.searchCsr.forEach(csr => {
        items.push({ url: '/csr', type: 'csr' });
      });
      return items;
    },
    hasResults() {
      return this.totalResults > 0;
    },
    noResults() {
      return !this.searchLoading && this.searchQuery.length > 2 && !this.hasResults;
    },
    hasTriggerAlert() {
      if (!this.tasks || !this.tasks.length) return false;
      return this.tasks.some(t => this.taskHasTriggerAlert(t));
    },
    displayTasks() {
      return (this.tasks || []).filter(t => {
        if (t.is_recurring) {
          const recs = t.recurring_tasks || t._raw?.recurring_tasks || [];
          if (!recs.some(r => r.status === 'New')) return false;
        }
        if (!this.isTaskShowEligible(t)) return false;
        return true;
      }).slice(0, 10);
    },
  },

  created() {
    this.$store.commit('getMenus');
  },
  mounted() {
    this.loadOU();
    this.loadActiveOU();
    document.addEventListener('scroll', function () {
      var pageTopbar = document.getElementById('page-topbar');
      if (pageTopbar) {
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
          ? pageTopbar.classList.add('topbar-shadow')
          : pageTopbar.classList.remove('topbar-shadow');
      }
    });
    if (document.getElementById('topnav-hamburger-icon'))
      document
        .getElementById('topnav-hamburger-icon')
        .addEventListener('click', this.toggleHamburgerMenu);

    document.addEventListener('click', this.handleClickOutside);
    this.initTopbarComponents();
    this.fetchTaskCount();
    this.fetchTasks().then(() => {
      // Arm the alert sound tracker: don't ring for alarms already active on load.
      this.checkAndPlayAlertSounds(true);
    });
    this.listenForTasks();


    // Warm up the AudioContext on the first user gesture so the alert bell can
    // actually play when a trigger fires (browsers block autoplay until then).
    this._warmAudio = () => {
      try {
        if (!this.audioCtx) {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (AudioCtx) this.audioCtx = new AudioCtx();
        }
        if (this.audioCtx && this.audioCtx.state === 'suspended') {
          const p = this.audioCtx.resume();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        }
      } catch (e) {
        // Audio is best-effort; ignore unsupported API errors.
      }
      window.removeEventListener('pointerdown', this._warmAudio);
      window.removeEventListener('keydown', this._warmAudio);
    };
    window.addEventListener('pointerdown', this._warmAudio);
    window.addEventListener('keydown', this._warmAudio);
  },
  beforeUnmount() {
    if (this.audioCtx && typeof this.audioCtx.close === 'function') {
      try {
        if (this.audioCtx.state !== 'closed') {
          const p = this.audioCtx.close();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        }
      } catch (e) {
        // ignore audio cleanup error
      }
      this.audioCtx = null;
    }
    if (this._warmAudio) {
      window.removeEventListener('pointerdown', this._warmAudio);
      window.removeEventListener('keydown', this._warmAudio);
    }
    document.removeEventListener('click', this.handleClickOutside);
    clearTimeout(this.searchTimer);
    this.stopTaskClockTimer();
    this.stopListeningForTasks();
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <application-logo />
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <!-- <img src="@/assets/images/logo-light.png" alt="" height="17" /> -->
                <application-logo />
              </span>
            </router-link>
          </div>

          <button
            type="button"
            class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
            id="topnav-hamburger-icon"
          >
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <!-- App Search-->
          <div class="d-none d-md-flex align-items-center nav-search-wrapper">
            <div class="nav-search-box">
              <input
                type="text"
                class="form-control nav-search-input"
                v-model="searchQuery"
                @input="onSearchInput"
                @focus="onFocusSearch"
                @keydown="handleKeydown"
                placeholder="Search menus, documents..."
                autocomplete="off"
              />
              <i class="ri-search-line nav-search-icon" v-if="!searchQuery"></i>
              <button
                v-if="searchQuery"
                class="nav-search-clear"
                @click="clearSearch"
                type="button"
              >
                <i class="ri-close-line"></i>
              </button>
            </div>

            <Transition name="dropdown-fade">
              <div
                v-if="searchDropdownOpen"
                class="nav-search-dropdown"
              >
                <div class="nav-search-dropdown-inner">
                    <div class="nav-search-scroll">
                      <template v-if="searchLoading">
                        <div class="nav-search-section">
                          <div class="nav-search-skeleton-title"></div>
                          <div class="nav-search-skeleton-item" v-for="n in 3" :key="'skel-' + n">
                            <div class="nav-search-skeleton-icon"></div>
                            <div class="nav-search-skeleton-text"></div>
                          </div>
                        </div>
                      </template>

                      <template v-else-if="noResults">
                        <div class="nav-search-empty">
                          <i class="ri-search-line"></i>
                          <p>No results found for "<strong>{{ searchQuery }}</strong>"</p>
                        </div>
                      </template>

                      <template v-else>
                        <template v-if="suggested_menu.length > 0">
                          <div class="nav-search-section">
                            <div class="nav-search-section-title">
                              <i class="ri-apps-line"></i>
                              <span>Menus</span>
                              <span class="nav-search-count">{{ suggested_menu.length }}</span>
                            </div>
                            <div
                              v-for="(menu, index) in suggested_menu"
                              :key="'menu-' + index"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === index }"
                            >
                              <router-link :to="menu.url" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon">
                                  <i :class="menu.icon ?? 'ri-menu-line'"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ menu.name }}</span>
                                  <span v-if="menu.children && menu.children.length > 0" class="nav-search-item-badge">
                                    {{ menu.children.length }} submenu{{ menu.children.length > 1 ? 's' : '' }}
                                  </span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </router-link>
                            </div>
                          </div>
                        </template>

                        <template v-if="otherDocuments.length > 0">
                          <div
                            v-for="(docGroup, groupIndex) in otherDocuments"
                            :key="'docgroup-' + groupIndex"
                            class="nav-search-section"
                          >
                            <div v-if="docGroup.length > 0" class="nav-search-section-title">
                              <i class="ri-file-text-line"></i>
                              <span>{{ docGroup[0].doc_type }}</span>
                              <span class="nav-search-count">{{ docGroup.length }}</span>
                            </div>
                            <div
                              v-for="(doc, docIndex) in docGroup"
                              :key="'doc-' + groupIndex + '-' + docIndex"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === (suggested_menu.length + docIndex) }"
                            >
                              <a :href="doc.generated_url" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon doc-icon">
                                  <i class="ri-file-text-line"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ doc.doc_no }}</span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </a>
                            </div>
                          </div>
                        </template>

                        <template v-if="searchUsers.length > 0">
                          <div class="nav-search-section">
                            <div class="nav-search-section-title">
                              <i class="ri-user-line"></i>
                              <span>Users</span>
                              <span class="nav-search-count">{{ searchUsers.length }}</span>
                            </div>
                            <div
                              v-for="(u, index) in searchUsers"
                              :key="'user-' + index"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === (suggested_menu.length + index) }"
                            >
                              <router-link to="/user-management/users" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon user-icon">
                                  <i class="ri-user-line"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ u.firstname }} {{ u.lastname }}</span>
                                  <span class="nav-search-item-badge">{{ u.username }}</span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </router-link>
                            </div>
                          </div>
                        </template>

                        <template v-if="searchCustomers.length > 0">
                          <div class="nav-search-section">
                            <div class="nav-search-section-title">
                              <i class="ri-building-line"></i>
                              <span>Customers</span>
                              <span class="nav-search-count">{{ searchCustomers.length }}</span>
                            </div>
                            <div
                              v-for="(c, index) in searchCustomers"
                              :key="'cust-' + index"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === (suggested_menu.length + searchUsers.length + index) }"
                            >
                              <router-link :to="'/customers/profile/' + c.customer_id" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon customer-icon">
                                  <i class="ri-building-line"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ c.customer_name }}</span>
                                  <span class="nav-search-item-badge">{{ c.customer_code }}</span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </router-link>
                            </div>
                          </div>
                        </template>

                        <template v-if="searchBookings.length > 0">
                          <div class="nav-search-section">
                            <div class="nav-search-section-title">
                              <i class="ri-book-open-line"></i>
                              <span>Bookings</span>
                              <span class="nav-search-count">{{ searchBookings.length }}</span>
                            </div>
                            <div
                              v-for="(b, index) in searchBookings"
                              :key="'bk-' + index"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === (suggested_menu.length + searchUsers.length + searchCustomers.length + index) }"
                            >
                              <router-link to="/booking" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon booking-icon">
                                  <i class="ri-book-open-line"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ b.booking_number }}</span>
                                  <span class="nav-search-item-badge">{{ b.customer_name }}</span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </router-link>
                            </div>
                          </div>
                        </template>

                        <template v-if="searchCsr.length > 0">
                          <div class="nav-search-section">
                            <div class="nav-search-section-title">
                              <i class="ri-file-list-line"></i>
                              <span>CSR</span>
                              <span class="nav-search-count">{{ searchCsr.length }}</span>
                            </div>
                            <div
                              v-for="(csr, index) in searchCsr"
                              :key="'csr-' + index"
                              class="nav-search-item"
                              :class="{ 'active': activeIndex === (suggested_menu.length + searchUsers.length + searchCustomers.length + searchBookings.length + index) }"
                            >
                              <router-link to="/csr" class="nav-search-item-link" @click="searchDropdownOpen = false">
                                <div class="nav-search-item-icon csr-icon">
                                  <i class="ri-file-list-line"></i>
                                </div>
                                <div class="nav-search-item-content">
                                  <span class="nav-search-item-name">{{ csr.csr_reference }}</span>
                                  <span class="nav-search-item-badge">{{ csr.customer_name }}</span>
                                </div>
                                <i class="ri-arrow-right-line nav-search-item-arrow"></i>
                              </router-link>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>

                  <div v-if="hasResults && !searchLoading" class="nav-search-footer">
                    <span class="nav-search-footer-hint">
                      <kbd>↑</kbd> <kbd>↓</kbd> to navigate · <kbd>↵</kbd> to select
                    </span>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <div class="dropdown d-md-none topbar-head-dropdown header-item">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
              id="page-header-search-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="bx bx-search fs-22"></i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
              aria-labelledby="page-header-search-dropdown"
            >
              <form class="p-3">
                <div class="form-group m-0">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search ..."
                      aria-label="Recipient's username"
                    />
                    <b-button variant="primary" type="submit">
                      <i class="mdi mdi-magnify"></i>
                    </b-button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="ms-1 header-item d-sm-flex">
            <!-- <ouDropdown @change="handleOUselect" v-model="ouCode" /> -->
            <select
              class="form-select w-xl"
              :readonly="ouAccess.length <= 1"
              @change="handleOUselect"
              v-model="ouCode"
              
            >
              <option
                v-for="(row, index) in ouAccess"
                :key="index"
                :value="row.ou_code"
              >
                {{ row.ou_name }}
              </option>
            </select>
          </div>
          <div class="ms-1 header-item d-none d-sm-flex">
            <b-button
              type="button"
              variant="ghost-dark"
              class="btn-icon btn-topbar rounded-circle"
              data-toggle="fullscreen"
              @click="initFullScreen"
            >
              <i class="bx bx-fullscreen fs-22"></i>
            </b-button>
          </div>

          <div class="ms-1 header-item d-none d-sm-flex">
            <b-button
              type="button"
              variant="ghost-dark"
              class="btn-icon btn-topbar rounded-circle light-dark-mode"
              @click="toggleDarkMode"
            >
              <i class="bx bx-moon fs-22"></i>
            </b-button>
          </div>

          <!-- Task Count Dropdown -->
          <div class="dropdown ms-1 header-item d-none d-sm-flex task-dropdown-wrapper" style="position: relative;">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle position-relative task-btn"
              :class="{ 'has-alert-trigger': hasTriggerAlert }"
              id="page-header-tasks-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              title="My Tasks"
            >
              <i class="bx bx-list-check fs-22" :class="{ 'text-danger': hasTriggerAlert }"></i>
              <span class="task-badge" :class="{ 'has-count': taskCount > 0, 'bg-danger text-white': hasTriggerAlert }">{{ taskCount > 0 ? (taskCount > 99 ? '99+' : taskCount) : '' }}</span>
              <span v-if="hasTriggerAlert" class="task-badge-alert-dot"></span>
            </button>
            <!-- Pulse waves placed OUTSIDE the button so overflow:hidden doesn't clip them -->
            <span v-if="hasTriggerAlert" class="task-btn-pulse-wave"></span>
            <span v-if="hasTriggerAlert" class="task-btn-pulse-wave-2"></span>

            <!-- Dropdown panel -->
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
              aria-labelledby="page-header-tasks-dropdown"
              style="min-width: 360px;"
            >
              <!-- Header -->
              <div class="p-3 border-bottom d-flex align-items-center justify-content-between">
                <div>
                  <h6 class="mb-0 fw-semibold">My Tasks</h6>
                  <small class="text-muted">{{ taskCount }} total</small>
                </div>
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-ghost-secondary rounded-circle task-alarm-sound-toggle"
                  :class="{ 'task-alarm-sound-off': !alertSoundEnabled }"
                  :title="alertSoundEnabled ? 'Mute task alarm sound' : 'Unmute task alarm sound'"
                  @click="toggleAlertSound"
                >
                  <i :class="alertSoundEnabled ? 'ri-volume-up-line' : 'ri-volume-mute-line'"></i>
                </button>
              </div>

              <!-- Loading -->
              <div v-if="taskLoading" class="text-center py-4">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <p class="mt-2 mb-0 text-muted small">Loading…</p>
              </div>

              <!-- Empty state -->
              <div v-else-if="tasks.length === 0" class="text-center py-5 px-3">
                <i class="bx bx-list-check fs-1 text-muted"></i>
                <p class="mt-2 mb-0 text-muted">No tasks assigned</p>
              </div>

              <!-- Task list -->
              <ul v-else class="list-unstyled mb-0">
                <li
                  v-for="t in displayTasks"
                  :key="t.id"
                  class="d-flex align-items-start gap-3 px-3 py-2 border-bottom notification-item"
                  :class="{ 'bg-soft-danger-subtle': taskHasTriggerAlert(t) }"
                >
                  <div class="flex-shrink-0 mt-1 d-flex align-items-center" style="height: 100%;">
                    <input
                      type="checkbox"
                      class="task-checkbox"
                      :checked="t.status === 'Completed'"
                      :title="isTaskAutoCompleted(t) ? 'Auto-completion trigger enabled (click to view details)' : (t.status === 'Completed' ? 'Mark as In Progress' : 'Mark as Completed')"
                      @click.prevent.stop="handleTaskCheckboxClick(t)"
                    />
                  </div>
                  <div class="flex-grow-1 overflow-hidden" @click="handleTaskClick(t)">
                    <div class="d-flex align-items-center gap-1">
                      <p class="mb-0 text-truncate small fw-medium" :title="t.title">{{ t.title }}</p>
                      <template v-if="getTriggerCountdownInfo(t)">
                        <span v-if="getTriggerCountdownInfo(t).isAlert" class="badge bg-danger text-white fs-10 px-1 py-0 ms-1 pulse-alert-badge" title="Trigger alert reached">
                          <i class="ri-notification-3-fill me-1"></i>ALERT
                        </span>
                        <span v-else class="badge bg-info-subtle text-info fs-10 px-1 py-0 ms-1" :title="getTriggerCountdownInfo(t).text" style="font-size: 10px;">
                          <i class="ri-timer-line me-1"></i>{{ getTriggerCountdownInfo(t).label }}
                        </span>
                      </template>
                    </div>
                    <p
                      v-if="t.description"
                      class="mb-0 text-muted text-truncate mt-1"
                      :title="t.description"
                      style="font-size: 11px; color: #6c757d; line-height: 1.35;"
                    >
                      {{ shortDesc(t.description) }}
                    </p>
                    <small class="text-muted d-flex align-items-center flex-wrap gap-1 mt-1">
                      <template v-if="t.is_recurring && (t.recurring_module || t.recurring_reference)">
                        <span class="badge bg-purple-subtle text-purple px-1 py-0" style="font-size: 9px; background-color: #f3f0ff; color: #7048e8; border: 1px solid #d0bfff;">
                          <i class="ri-repeat-line me-1"></i>Recurring
                        </span>
                        <span class="fw-semibold text-dark">{{ t.recurring_module }}</span>
                        <span v-if="t.recurring_reference" class="text-dark">/ {{ t.recurring_reference }}</span>
                        <span v-if="t.module && t.module_reference" class="text-muted opacity-75 ms-1" style="font-size: 9.5px;">({{ t.module }}/{{ t.module_reference }})</span>
                      </template>
                      <template v-else>
                        <span>{{ t.module }}</span>
                        <span v-if="t.module_reference">/ {{ t.module_reference }}</span>
                      </template>
                    </small>
                    <span v-if="getDueInfo(t.due_date)" class="d-inline-block mt-1">
                      <span class="badge" :class="getDueInfo(t.due_date).listClass" style="font-size: 0.6rem; font-weight: 500;">
                        {{ getDueInfo(t.due_date).label }}
                      </span>
                    </span>
                    <small class="d-block text-muted mt-1" style="font-size: 10px;">{{ timeAgo(t.created_at) }}</small>
                  </div>
                  <span class="flex-shrink-0 mt-1">
                    <span :class="'badge bg-' + (t.priority === 'Urgent' ? 'danger' : t.priority === 'High' ? 'warning' : t.priority === 'Medium' ? 'info' : 'success')" style="font-size: 0.65rem;">
                      {{ t.priority }}
                    </span>
                  </span>
                </li>
              </ul>

              <!-- View All Footer -->
              <div class="p-2 border-top text-center">
                <router-link :to="{ path: '/my-shared-tasks', query: { view: 'assigned' } }" class="btn btn-link btn-sm text-decoration-none shadow-none fw-bold" style="color: #a72b2b;">
                  View All <i class="ri-arrow-right-line align-middle"></i>
                </router-link>
              </div>
            </div>
          </div>

          <Notifications />


          <div
            class="dropdown ms-sm-3 header-item topbar-user"
          >
            <button
              type="button"
              class="btn"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="d-flex align-items-center">
                <img
                  class="rounded-circle header-profile-user"
                  src="@/assets/images/users/aai_box2.jpg"
                  alt="Header Avatar"
                />
                <span class="text-start ms-xl-2">
                  <span
                    class="d-none d-xl-inline-block ms-1 fw-medium user-name-text"
                    >{{ user.firstname + " " + user.lastname }}</span
                  >
                  <!-- <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{{ user.email }}</span> -->
                </span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- <h6 class="dropdown-header">Welcome Anna!</h6> -->
              <router-link class="dropdown-item" to="/my-profile"
                ><i
                  class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"
                ></i>
                <span class="align-middle">Profile</span>
              </router-link>

              <div class="dropdown-divider"></div>
              <b-link class="dropdown-item" href="/logout"
                ><i
                  class="mdi mdi-logout text-muted fs-16 align-middle me-1"
                ></i>
                <span class="align-middle" data-key="t-logout">Logout</span>
              </b-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.bg-gradient {
  background: #acadac;
}
.bg-gradient-2 {
  background: transparent !important;
}

.nav-search-wrapper {
  position: relative;
}

.nav-search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-search-input {
  width: 280px;
  height: 40px;
  padding: 0 36px 0 40px;
  border-radius: 10px;
  border: 1px solid var(--vz-border-color);
  background: var(--vz-topbar-search-bg);
  color: var(--vz-body-color);
  font-size: 13px;
  transition: all 0.2s ease;
}

.nav-search-input:focus {
  width: 320px;
  background: var(--vz-card-bg-custom);
  border-color: var(--app-primary);
  box-shadow: 0 0 0 3px rgb(var(--app-primary-rgb) / 10%);
  outline: none;
}

.nav-search-input::placeholder {
  color: var(--vz-secondary-color);
}

.nav-search-icon {
  position: absolute;
  left: 12px;
  color: #9ca3af;
  font-size: 16px;
  pointer-events: none;
}

.nav-search-clear {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: var(--vz-light);
  color: var(--vz-secondary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
  font-size: 14px;
}

.nav-search-clear:hover {
  background: rgb(var(--app-primary-rgb) / 15%);
  color: var(--app-primary);
}

.nav-search-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 380px;
  z-index: 1050;
}

.nav-search-dropdown-inner {
  background: var(--vz-card-bg-custom);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--vz-border-color);
  overflow: hidden;
}

.nav-search-scroll {
  max-height: 360px;
  overflow-y: auto;
  padding: 8px;
}

.nav-search-scroll::-webkit-scrollbar {
  width: 6px;
}

.nav-search-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.nav-search-scroll::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.nav-search-section {
  margin-bottom: 4px;
}

.nav-search-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--vz-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-search-section-title i {
  font-size: 14px;
  color: #9ca3af;
}

.nav-search-count {
  margin-left: auto;
  background: var(--vz-light);
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 500;
  color: var(--vz-secondary-color);
}

.nav-search-item {
  border-radius: 8px;
  transition: background-color 0.15s ease;
}

.nav-search-item:hover,
.nav-search-item.active {
  background: rgb(var(--app-primary-rgb) / 10%);
}

.nav-search-item-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  text-decoration: none;
  color: inherit;
}

.nav-search-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.nav-search-item-icon.doc-icon {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.nav-search-item-icon.user-icon {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}

.nav-search-item-icon.customer-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
}

.nav-search-item-icon.booking-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
}

.nav-search-item-icon.csr-icon {
  background: linear-gradient(135deg, #ec4899 0%, #f43f5e 100%);
}

.nav-search-item-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nav-search-item-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--vz-body-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-search-item-badge {
  font-size: 11px;
  color: var(--vz-secondary-color);
}

.nav-search-item-arrow {
  color: #d1d5db;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.nav-search-item:hover .nav-search-item-arrow,
.nav-search-item.active .nav-search-item-arrow {
  opacity: 1;
}

.nav-search-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #9ca3af;
}

.nav-search-empty i {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.nav-search-empty p {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.nav-search-footer {
  padding: 10px 16px;
  border-top: 1px solid #f3f4f6;
  background: #fafafa;
}

.nav-search-footer-hint {
  font-size: 11px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  gap: 4px;
}

.task-btn {
  position: relative;
  overflow: visible !important;
}

.task-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e53935;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  pointer-events: none;
  display: none;
  box-shadow: 0 0 0 2px #fff;
  z-index: 5;
}

.task-badge.has-count {
  display: inline-block;
}

.nav-search-footer-hint kbd {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-family: inherit;
  color: #6b7280;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.nav-search-skeleton-title {
  height: 10px;
  width: 60px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
  margin: 8px 12px 10px;
}

.nav-search-skeleton-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}

.nav-search-skeleton-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  flex-shrink: 0;
}

.nav-search-skeleton-text {
  height: 12px;
  width: 100%;
  max-width: 180px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.nav-search-skeleton-item:nth-child(3) .nav-search-skeleton-text {
  max-width: 140px;
}

.nav-search-skeleton-item:nth-child(4) .nav-search-skeleton-text {
  max-width: 160px;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.notification-item:hover {
    background-color: #f8f9fa;
}

.task-alarm-sound-toggle {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.task-alarm-sound-toggle.task-alarm-sound-off {
  color: #adb5bd;
}
.task-alarm-sound-off i {
  opacity: 0.6;
}

.task-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #a72b2b;
  border-radius: 4px;
  transition: transform 0.15s ease, opacity 0.15s ease;
  pointer-events: auto;
}

.task-checkbox:hover {
  transform: scale(1.2);
}

.task-checkbox:checked {
  accent-color: #2f9e44;
}

.task-checkbox:not(:checked) {
  opacity: 0.65;
}

.task-checkbox:not(:checked):hover {
  opacity: 1;
}
</style>

<!-- Task View Modal Styles (non-scoped) -->
<style>
.task-view-swal-popup {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
  border: 1px solid rgba(255,255,255,0.08) !important;
}
.tp-close-btn {
  color: rgba(255,255,255,0.8) !important;
  top: 14px !important;
  right: 14px !important;
  font-size: 20px !important;
  z-index: 10 !important;
  transition: all 0.2s ease !important;
  text-shadow: 0 1px 4px rgba(0,0,0,0.3) !important;
}
.tp-close-btn:hover {
  color: #fff !important;
  transform: scale(1.15) !important;
}

/* ═══ Modal Container ═══ */
.tp-modal {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #f7f8fc;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}
.tp-modal::-webkit-scrollbar { width: 5px; }
.tp-modal::-webkit-scrollbar-track { background: transparent; }
.tp-modal::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }

/* ═══ Hero Header ═══ */
.tp-hero {
  position: relative;
  padding: 28px 28px 24px;
  overflow: hidden;
}
.tp-hero-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.07;
  background-image: radial-gradient(circle at 20% 50%, rgba(255,255,255,0.8) 1px, transparent 1px),
                     radial-gradient(circle at 80% 20%, rgba(255,255,255,0.6) 1px, transparent 1px),
                     radial-gradient(circle at 60% 80%, rgba(255,255,255,0.5) 1px, transparent 1px);
  background-size: 40px 40px, 60px 60px, 50px 50px;
  animation: tp-float 20s ease-in-out infinite;
}
@keyframes tp-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-4px) rotate(0.5deg); }
}
.tp-hero-content {
  position: relative;
  z-index: 2;
}
.tp-hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.tp-hero-id {
  font-family: 'SFMono-Regular', 'Consolas', monospace;
  font-size: 12px;
  font-weight: 700;
  color: rgba(255,255,255,0.7);
  background: rgba(255,255,255,0.12);
  padding: 4px 10px;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.15);
  letter-spacing: 0.5px;
}
.tp-hero-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.2);
}
.tp-hero-status-pill i { font-size: 13px; }
.tp-st-new { background: rgba(255,255,255,0.18); color: #fff; }
.tp-st-progress { background: rgba(255,255,255,0.18); color: #fff; }
.tp-st-pending { background: rgba(255,255,255,0.18); color: #fff; }
.tp-st-hold { background: rgba(255,255,255,0.18); color: #fff; }
.tp-st-completed { background: rgba(255,255,255,0.22); color: #fff; }
.tp-st-cancelled { background: rgba(255,255,255,0.18); color: #fff; }

.tp-hero-title {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  line-height: 1.3;
  word-break: break-word;
  text-shadow: 0 1px 3px rgba(0,0,0,0.15);
  letter-spacing: -0.3px;
}

.tp-hero-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.tp-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255,255,255,0.9);
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255,255,255,0.1);
  transition: all 0.2s ease;
}
.tp-hero-chip:hover { background: rgba(255,255,255,0.2); }
.tp-hero-chip i { font-size: 12px; }
.tp-hero-chip-ref {
  font-family: 'SFMono-Regular', 'Consolas', monospace;
  letter-spacing: 0.3px;
}

/* Priority chip colors (in hero) */
.tp-pri-low { background: rgba(16,185,129,0.2) !important; color: #a7f3d0 !important; border-color: rgba(16,185,129,0.3) !important; }
.tp-pri-medium { background: rgba(59,130,246,0.2) !important; color: #bfdbfe !important; border-color: rgba(59,130,246,0.3) !important; }
.tp-pri-high { 
  background: #ea580c !important; 
  color: #ffffff !important; 
  border-color: #f97316 !important; 
  font-weight: 700 !important; 
  box-shadow: 0 2px 8px rgba(234, 88, 12, 0.45) !important;
}
.tp-pri-high i { color: #ffffff !important; }
.tp-pri-high:hover {
  background: #c2410c !important;
  color: #ffffff !important;
}
.tp-pri-urgent { 
  background: #dc2626 !important; 
  color: #ffffff !important; 
  border-color: #ef4444 !important; 
  font-weight: 700 !important; 
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.45) !important;
}
.tp-pri-urgent i { color: #ffffff !important; }
.tp-pri-urgent:hover {
  background: #b91c1c !important;
  color: #ffffff !important;
}

/* Due date chips */
.tp-due-overdue { background: rgba(239,68,68,0.3) !important; border-color: rgba(255,100,100,0.3) !important; }
.tp-due-today { background: rgba(245,158,11,0.3) !important; }
.tp-due-soon { background: rgba(234,179,8,0.25) !important; }
.tp-due-ok { background: rgba(16,185,129,0.2) !important; }

/* ═══ Timeline Progress Bar ═══ */
.tp-timeline-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 18px 32px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}
.tp-tl-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.tp-tl-dot {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #f1f5f9;
  color: #94a3b8;
  border: 2px solid #e2e8f0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.tp-tl-label {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}
.tp-tl-active .tp-tl-dot {
  background: #a72b2b;
  color: #fff;
  border-color: #a72b2b;
  box-shadow: 0 0 0 4px rgba(167, 43, 43, 0.15);
}
.tp-tl-active .tp-tl-label { color: #a72b2b; }
.tp-tl-current .tp-tl-dot {
  box-shadow: 0 0 0 4px rgba(167, 43, 43, 0.2), 0 2px 8px rgba(167, 43, 43, 0.3);
  animation: tp-pulse-dot 2s ease-in-out infinite;
}
.tp-tl-cancelled .tp-tl-dot {
  background: #1f2937 !important;
  border-color: #1f2937 !important;
  box-shadow: 0 0 0 4px rgba(31, 41, 55, 0.15) !important;
}
.tp-tl-cancelled .tp-tl-label { color: #1f2937 !important; }
@keyframes tp-pulse-dot {
  0%, 100% { box-shadow: 0 0 0 4px rgba(167, 43, 43, 0.2), 0 2px 8px rgba(167, 43, 43, 0.3); }
  50% { box-shadow: 0 0 0 6px rgba(167, 43, 43, 0.1), 0 2px 12px rgba(167, 43, 43, 0.2); }
}
.tp-tl-connector {
  width: 60px;
  height: 3px;
  background: #e2e8f0;
  border-radius: 2px;
  margin: 0 4px;
  margin-bottom: 22px;
  transition: background 0.4s ease;
}
.tp-tl-conn-active {
  background: linear-gradient(90deg, #a72b2b, #c94444);
}

/* ═══ Body ═══ */
.tp-body {
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ═══ Info Cards ═══ */
.tp-info-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.tp-info-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.tp-info-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  transform: translateY(-1px);
}
.tp-info-card-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.tp-info-card-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.tp-info-card-label {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.tp-info-card-value {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ═══ Cards ═══ */
.tp-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: box-shadow 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.tp-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.tp-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 700;
  color: #4b5563;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.tp-card-header i {
  font-size: 15px;
  color: #a72b2b;
}
.tp-card-header-action i {
  color: #a72b2b;
}
.tp-card-count {
  margin-left: auto;
  background: #a72b2b;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}
.tp-card-body {
  padding: 16px 18px;
}

/* Description */
.tp-desc-body {
  font-size: 13px;
  line-height: 1.7;
  color: #374151;
  word-break: break-word;
}
.tp-empty {
  color: #9ca3af;
  font-style: italic;
  font-size: 13px;
}

/* ═══ Responsibles ═══ */
.tp-resp-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tp-resp-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.tp-resp-item:hover {
  background: #f3f4f6;
  border-color: #e5e7eb;
  transform: translateX(3px);
}
.tp-resp-avatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  background: linear-gradient(135deg, #a72b2b, #c94444);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(167, 43, 43, 0.2);
}
.tp-resp-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.tp-resp-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tp-resp-type {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ═══ Update Form ═══ */
.tp-card-update {
  border-color: #fecaca;
  background: linear-gradient(135deg, #fefefe 0%, #fff5f5 100%);
}
.tp-form-grid {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tp-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.tp-form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.tp-form-label i {
  font-size: 13px;
  color: #a72b2b;
}
.tp-form-select {
  width: 100%;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  outline: none;
  transition: all 0.25s ease;
  cursor: pointer;
  appearance: auto;
}
.tp-form-select:focus {
  border-color: #a72b2b;
  box-shadow: 0 0 0 3px rgba(167, 43, 43, 0.1);
}
.tp-form-textarea {
  width: 100%;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 400;
  color: #1f2937;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  outline: none;
  resize: vertical;
  font-family: inherit;
  line-height: 1.6;
  transition: all 0.25s ease;
}
.tp-form-textarea:focus {
  border-color: #a72b2b;
  box-shadow: 0 0 0 3px rgba(167, 43, 43, 0.1);
}
.tp-form-textarea::placeholder {
  color: #9ca3af;
}

/* Card Footer */
.tp-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px 16px;
  border-top: 1px solid #f3f4f6;
}
.tp-update-msg {
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 5px;
}
.tp-msg-success { color: #059669; }
.tp-msg-error { color: #dc2626; }

/* Save Button */
.tp-save-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 24px;
  font-size: 12.5px;
  font-weight: 700;
  color: #fff;
  background: #111111;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.tp-save-btn:hover:not(:disabled) {
  background: #a72b2b;
  box-shadow: 0 6px 20px rgba(167, 43, 43, 0.35);
  transform: translateY(-1px);
}
.tp-save-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.tp-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.tp-save-btn i { font-size: 14px; }

/* Spinner */
.tp-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: tp-spin 0.6s linear infinite;
}
@keyframes tp-spin {
  to { transform: rotate(360deg); }
}

/* ═══ Notice Card (Recurring / Auto-completion) ═══ */
.tp-card-notice {
  background: #fafafa;
  border-left: 4px solid #111111;
}
.tp-notice-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  background: rgba(17, 17, 17, 0.08);
  color: #111111;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.tp-notice-text {
  font-size: 12.5px;
  color: #4b5563;
  line-height: 1.5;
}

/* ═══ Notification Alarm Section ═══ */
.tp-card-alarm {
  border-color: #e5e7eb;
}
.tp-alarm-ringing-badge {
  margin-left: auto;
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  animation: tp-pulse-alarm 1.5s ease-in-out infinite alternate;
}
@keyframes tp-pulse-alarm {
  from { opacity: 0.85; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1.03); box-shadow: 0 0 8px rgba(220, 38, 38, 0.5); }
}
.tp-alarm-status-box {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 500;
  color: #374151;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
}
.tp-alarm-extend-box {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.tp-alarm-label {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.tp-pill-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.tp-alarm-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1.5px solid #e5e7eb;
  background: #fff;
  color: #374151;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tp-alarm-pill:hover {
  background: #fff5f5;
  border-color: #a72b2b;
  color: #a72b2b;
  transform: translateY(-1px);
}
.tp-alarm-pill:active {
  transform: translateY(0);
}
.tp-alarm-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 500;
  margin-top: 4px;
}
.tp-alarm-hint i {
  color: #a72b2b;
  font-size: 13px;
}
.tp-alarm-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px 16px;
  border-top: 1px solid #f3f4f6;
}
.tp-alarm-msg {
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 5px;
}
.tp-alarm-off-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  font-size: 12px;
  font-weight: 700;
  color: #dc2626;
  background: #fff;
  border: 1.5px solid #dc2626;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
}
.tp-alarm-off-btn:hover {
  background: #dc2626;
  color: #fff;
  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.25);
  transform: translateY(-1px);
}
.tp-alarm-off-btn:active {
  transform: translateY(0);
}
.tp-alarm-off-btn i {
  font-size: 14px;
}

/* ═══ Responsive ═══ */
@media (max-width: 640px) {
  .tp-info-cards { grid-template-columns: 1fr; }
  .tp-hero { padding: 22px 20px 20px; }
  .tp-hero-title { font-size: 17px; }
  .tp-body { padding: 16px 16px 20px; }
  .tp-timeline-bar { padding: 14px 16px; }
  .tp-tl-connector { width: 30px; }
}

/* ===== Pulse Wave Alert Animation for Task Button ===== */
.task-dropdown-wrapper {
  overflow: visible !important;
}

.task-btn {
  position: relative;
  overflow: visible !important;
  transition: all 0.3s ease;
}

.task-btn.has-alert-trigger {
  color: #b30300 !important;
  background: rgba(229, 57, 53, 0.12) !important;
}

.task-btn-pulse-wave,
.task-btn-pulse-wave-2 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid #e53935;  /* thin solid red ring */
  background: transparent;
  pointer-events: none;
  z-index: 0;
  animation: pulse-wave-ripple 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

.task-btn-pulse-wave-2 {
  animation-delay: 0.6s;  /* twin pulse — second ring offset */
}


@keyframes pulse-wave-ripple {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  70% {
    opacity: 0.4;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.2);
    opacity: 0;
  }
}

.task-badge-alert-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 9px;
  height: 9px;
  background-color: #e53935;
  border: 1.5px solid #ffffff;
  border-radius: 50%;
  animation: pulse-dot-glow 1.2s ease-in-out infinite alternate;
}

@keyframes pulse-dot-glow {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.7);
  }
  100% {
    transform: scale(1.25);
    box-shadow: 0 0 8px 4px rgba(229, 57, 53, 0.5);
  }
}

.pulse-alert-badge {
  animation: pulse-badge-glow 1.5s ease-in-out infinite alternate;
}

@keyframes pulse-badge-glow {
  0% {
    opacity: 0.8;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
    box-shadow: 0 0 6px rgba(229, 57, 53, 0.6);
  }
}

.bg-soft-danger-subtle {
  background-color: rgba(229, 57, 53, 0.06) !important;
}
</style>
